import React, { Component } from 'react';

import SidebarComponent from '../components/SidebarComponent';
import NavbarComponent from '../components/NavbarComponent';
import HeaderComponent from '../components/HeaderComponent';
import { validateSession } from '../utils/functions';
import { getPrinterName, setPrinterName, listPrinters, printRawHex, isConnected } from '../utils/qzPrinter';

// Configuración de la impresora térmica por estación (ENI-40 impresión).
// El nombre elegido se guarda en localStorage ('qzPrinter'); con eso, el POS manda
// la comanda como ESC/POS crudo por QZ Tray en vez de abrir el diálogo del navegador.
// Sin impresora configurada, el POS cae al camino HTML (window.print()).

// Construye un ESC/POS mínimo (hex) para una impresión de prueba: init + texto + corte.
// Solo ASCII para no depender del encoding.
function testTicketHex() {
    const text = 'Prueba de impresion\nEnigma Games - Cafeteria\nImpresora OK\n';
    let body = '';
    for (let i = 0; i < text.length; i += 1) {
        body += (text.charCodeAt(i) & 0xff).toString(16).padStart(2, '0');
    }
    const init = '1b40'; // ESC @  (reset)
    const feedCut = '0a0a0a1d5600'; // 3 line feeds + GS V 0 (corte)
    return init + body + feedCut;
}

class CafeteriaImpresoraPage extends Component {
    constructor() {
        super();
        this.state = {
            checked: false,
            role: 0,
            printers: [],
            selected: getPrinterName(),
            loading: false,
            connected: false,
            testing: false,
            message: null,
            error: false,
        };
    }

    async componentDidMount() {
        const role = await validateSession();
        this.setState({ checked: true, role, connected: isConnected() });
    }

    refreshPrinters = () => {
        this.setState({ loading: true, message: null, error: false });
        listPrinters()
            .then((printers) => {
                const list = Array.isArray(printers) ? printers : [printers].filter(Boolean);
                this.setState({
                    printers: list,
                    connected: true,
                    loading: false,
                    // Si la guardada ya no está en la lista, la dejamos igual (puede estar offline).
                    selected: this.state.selected || (list.length === 1 ? list[0] : ''),
                });
            })
            .catch(() => {
                this.setState({
                    loading: false,
                    connected: false,
                    error: true,
                    message: 'No se pudo conectar con QZ Tray. Verificá que esté instalado y corriendo en esta PC.',
                });
            });
    }

    handleSelect = (e) => {
        this.setState({ selected: e.target.value, message: null, error: false });
    }

    save = () => {
        setPrinterName(this.state.selected);
        this.setState({
            message: this.state.selected
                ? `Impresora "${this.state.selected}" guardada para esta estación.`
                : 'Impresora quitada: el POS usará el diálogo del navegador.',
            error: false,
        });
    }

    useBrowser = () => {
        setPrinterName('');
        this.setState({ selected: '', message: 'Listo: el POS usará el diálogo del navegador (HTML).', error: false });
    }

    testPrint = () => {
        if (!this.state.selected) {
            this.setState({ message: 'Elegí una impresora antes de imprimir la prueba.', error: true });
            return;
        }
        this.setState({ testing: true, message: null, error: false });
        printRawHex(this.state.selected, testTicketHex())
            .then(() => this.setState({ testing: false, message: 'Prueba enviada a la impresora.', error: false }))
            .catch(() => this.setState({
                testing: false,
                error: true,
                message: 'Falló la impresión de prueba. Revisá que la impresora esté encendida y seleccionada.',
            }));
    }

    render() {
        if (!this.state.checked) {
            return (<div></div>);
        }
        const saved = getPrinterName();
        return (
            <div className="container-fluid">
                <div className="row">
                    <SidebarComponent itemSelected={30} role={this.state.role} />
                    <main className="main-content col-lg-10 col-md-9 col-sm-12 p-0 offset-lg-2 offset-md-3">
                        <NavbarComponent role={this.state.role} />
                        <div className="main-content-container container-fluid px-4 mb-4">
                            <HeaderComponent title="Cafetería" subtitle="Impresora térmica" />
                            <div className="card card-small mb-4">
                                <div className="card-body p-4">
                                    <p className="text-muted">
                                        Elegí la impresora térmica de esta estación. Con una impresora configurada, al cobrar
                                        se imprime la comanda directo (ESC/POS por QZ Tray), sin el diálogo del navegador.
                                        Requiere <strong>QZ Tray</strong> instalado y corriendo en esta PC.
                                    </p>

                                    <div className="mb-3">
                                        <span className={`badge ${this.state.connected ? 'badge-success' : 'badge-secondary'}`}>
                                            QZ Tray: {this.state.connected ? 'conectado' : 'sin conectar'}
                                        </span>
                                        {saved ? (
                                            <span className="badge badge-info ml-2">Guardada: {saved}</span>
                                        ) : (
                                            <span className="badge badge-warning ml-2">Sin impresora (usa navegador)</span>
                                        )}
                                    </div>

                                    <div className="form-row align-items-end">
                                        <div className="col-md-6">
                                            <div className="form-group mb-0">
                                                <label>Impresora</label>
                                                <select className="custom-select" value={this.state.selected} onChange={this.handleSelect} disabled={this.state.printers.length === 0}>
                                                    <option value="">
                                                        {this.state.printers.length === 0 ? 'Detectá las impresoras primero…' : 'Elegir…'}
                                                    </option>
                                                    {this.state.printers.map((p) => (<option key={p} value={p}>{p}</option>))}
                                                    {/* Si hay una guardada que no está en la lista (offline), la mostramos igual. */}
                                                    {this.state.selected && !this.state.printers.includes(this.state.selected) && (
                                                        <option value={this.state.selected}>{this.state.selected} (no detectada)</option>
                                                    )}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <button type="button" className="btn btn-outline-secondary" onClick={this.refreshPrinters} disabled={this.state.loading}>
                                                {this.state.loading ? 'Detectando…' : 'Detectar impresoras'}
                                            </button>
                                        </div>
                                    </div>

                                    <div className="mt-3">
                                        <button type="button" className="btn btn-accent mr-2" onClick={this.save}>Guardar</button>
                                        <button type="button" className="btn btn-outline-primary mr-2" onClick={this.testPrint} disabled={this.state.testing || !this.state.selected}>
                                            {this.state.testing ? 'Enviando…' : 'Imprimir prueba'}
                                        </button>
                                        <button type="button" className="btn btn-outline-secondary" onClick={this.useBrowser}>Usar navegador</button>
                                    </div>

                                    {this.state.message && (
                                        <div className={`mt-3 mb-0 alert ${this.state.error ? 'alert-danger' : 'alert-success'}`}>
                                            {this.state.message}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </main>
                </div>
            </div>
        );
    }
}

export default CafeteriaImpresoraPage;
